import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="16" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M19.98 2.55505C10.3234 2.55505 2.49512 10.3836 2.49512 20.0399C2.49512 29.6974 10.3233 37.5251 19.98 37.5251C29.6368 37.5251 37.4651 29.6974 37.4651 20.0399C37.4652 10.3836 29.6368 2.55505 19.98 2.55505ZM19.978 35.1966C11.6069 35.1966 4.82064 28.4107 4.82064 20.0392C4.82064 11.6684 11.6069 4.88161 19.978 4.88161C28.3493 4.88161 35.1354 11.6684 35.1354 20.0392C35.1354 28.4107 28.3494 35.1966 19.978 35.1966ZM14.8988 27.3407L26.8724 20.4601L14.8988 13.5799V27.3407Z"
      fill="currentColor"
    />
  </svg>
);
